module.exports = __webpack_public_path__ + "img/b_Anevil_up.6c84172a.jpeg";